<template>
  <SQDCBoardSelect
    v-model="selectedId"
    hide-label
    :variables="siteId == null ? {} : { siteIds: siteId }"
    required-right="sqdc.read"
    disabled-without-right="sqdc.read"
  />
</template>

<script setup lang="ts">
import { ref, watch } from "vue";
import SQDCBoardSelect from "@/modules/sqdc/components/selects/SQDCBoardSelect.vue";
import BoardFilter from "../filterImplementations/BoardFilter";
import { FilterUIProps } from "../FilterTypes";

const props = defineProps(FilterUIProps);
const selectedId = ref<number>();

watch(
  () => props.siteId,
  () => {
    selectedId.value = undefined;
  },
);

function getFilter() {
  return selectedId.value == null ? null : new BoardFilter(selectedId.value);
}
function applyFilter(filter: BoardFilter) {
  selectedId.value = filter.boardId;
}
defineExpose({ getFilter, applyFilter });
</script>
